import { render, staticRenderFns } from "./AjustesTopside.vue?vue&type=template&id=f39f6b1a&scoped=true"
import script from "./AjustesTopside.vue?vue&type=script&lang=js"
export * from "./AjustesTopside.vue?vue&type=script&lang=js"
import style0 from "./AjustesTopside.vue?vue&type=style&index=0&id=f39f6b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39f6b1a",
  null
  
)

export default component.exports